import { client } from "api";
import { Department } from "models/Department";

export type DeleteDepartmentRequest = { id: number };

export type DeleteDepartmentResponse = Department[];

export const deleteDepartment = ({ id }: DeleteDepartmentRequest) =>
  client.delete<DeleteDepartmentResponse>(`/department/${id}`).then((res) => res.data);
